import { usePermissionsRepository } from '@Hooks/useRepository';
import { ApplicationsRepository } from '@Repositories/Permissions';
import { useMutation } from '@tanstack/react-query';
import { useCallback } from 'react';

export const useBlockExternalApplication = (applicationId: string, onMutate: () => void) => {
    const applications = usePermissionsRepository(ApplicationsRepository);

    const { mutateAsync, isPending: blockApplicationIsPending } = useMutation({
        mutationFn: () => applications.blockApplication(applicationId),
    });

    const blockApplicationHandler = useCallback(async () => {
        await mutateAsync();
        onMutate();
    }, [mutateAsync, onMutate]);

    return { blockApplicationHandler, blockApplicationIsPending };
};
